export const incomeByCategoryMapping = (item: any) => ({
  CustomerCompanyName: item.categoryName,
  AllIncome: item.allIncome,
  PaidIncome: item.paidIncome,
});
